export const translation = {
  "home.hero.title": "Hipobuy Spreadsheet : Le Guide Complet pour Optimiser Votre Système de Tracking en 2026",
  "home.hero.subtitle": "Optimisez votre gestion de données avec un système structuré de hipobuy spreadsheet, conçu pour améliorer la performance, l'organisation et la prise de décision.",
  "home.hero.cta1": "Accéder au système Hipobuy Spreadsheet",
  "home.hero.cta2": "Buy It Now",
  "home.value.title": "Pourquoi utiliser un Hipobuy Spreadsheet ?",
  "home.value.item1": "Centralisation des données en un seul système",
  "home.value.item2": "Suivi structuré et automatisé",
  "home.value.item3": "Meilleure prise de décision basée sur les données",
  "home.value.item4": "Compatible avec les outils modernes (Google Sheets, Notion, Excel)",
  "home.seo.text": "Le hipobuy spreadsheet est devenu une méthode incontournable pour organiser et structurer les données de suivi. Ce guide vous montre comment utiliser efficacement un système de spreadsheet hipobuy pour améliorer vos résultats.",
  "home.featured.title": "Guides recommandés",
  "home.featured.guide1": "Guide complet Hipobuy Spreadsheet 2026",
  "home.featured.guide2": "Comparaison des meilleurs spreadsheets",
  "home.featured.guide3": "Automatisation avancée Hipobuy",
  "home.featured.guide4": "Templates gratuits",
  "home.categories.title": "Nos Catégories",
  "home.categories.desc": "Découvrez notre sélection de produits de mode à travers les catégories les plus populaires. Chaque catégorie offre une collection unique soigneusement choisie pour vous.",
  "home.cta.title": "Passez au niveau supérieur avec Hipobuy Spreadsheet",
  "home.cta.btn1": "Découvrez la plateforme complète",
  "home.cta.btn2": "Accédez aux outils avancés",
  "home.cta.btn3": "Optimisez votre workflow dès aujourd'hui",
  "home.nav.categories": "Catégories",
  "home.nav.allCategories": "Toutes les catégories",
  "home.footer.about": "À propos",
  "home.footer.legal": "Mentions légales",
  "home.footer.privacy": "Confidentialité",
  "home.footer.copyright": "© 2026 hipobuyspreadsheet.ink - Tous droits réservés",
  "home.footer.articles": "Articles SEO",
  "home.footer.article1": "Guide Hipobuy Spreadsheet",
  "home.footer.article2": "Comparaison",
  "home.footer.article3": "Templates",
  "home.footer.social": "Suivez-nous",
  "home.footer.contact": "Contact",
  "home.footer.address": "Adresse",
  "home.footer.phone": "Téléphone",
  "home.footer.email": "Email",
  "home.footer.street": "Paris, France",
  "home.footer.phoneNum": "+33 1 23 45 67 89",
  "home.footer.emailAddr": "contact@hipobuyspreadsheet.ink",
  "home.stats.products": "15K+ Produits",
  "home.stats.brands": "50+ Marques",
  "home.about.title": "Hipobuy Spreadsheet",
  "home.about.desc": "Hipobuy Spreadsheet est un système de gestion de données avancé développé pour les professionnels de la mode et du e-commerce. Notre plateforme vous permet de centraliser, organiser et analyser vos données de suivi en un seul endroit. Avec des connexions directes vers les sources européennes, nous vous offrons un accès privilégié aux meilleures collections de produits.",
  "home.about.tag": "Europe Direct",
  "home.about.cta": "Hipobuy Spreadsheet",
  "home.review.label": "Avis vérifié",
  "home.review.title": "Le meilleur spreadsheet mode",
  "home.review.text": "Hipobuy Spreadsheet a transformé ma façon de gérer mes stocks. La centralisation des données et les automatismes intégrés me font gagner des heures chaque semaine. Un outil indispensable pour tout entrepreneur en mode.",
  "home.review.author": "Marie L., Entrepreneur Mode",
  "home.conv.title": "Hipobuy Spreadsheet",
  "home.conv.subtitle": "Accédez à la plateforme complète",
  "home.conv.btn": "Buy It Now",
  "article.title": "Comment utiliser Hipobuy Spreadsheet (Guide Complet 2026)",
  "article.intro": "Le hipobuy spreadsheet est devenu une méthode incontournable pour organiser et structurer les données de suivi en 2026. Dans ce guide complet, nous vous montrons comment utiliser efficacement un système de spreadsheet hipobuy pour améliorer vos résultats et optimiser votre workflow.",
  "article.backHome": "Retour à l'accueil",
  "article.faq.title": "Questions fréquemment posées",
  "article.faq.q1": "Qu'est-ce que Hipobuy Spreadsheet ?",
  "article.faq.a1": "Hipobuy Spreadsheet est un système de gestion de données structuré qui permet de centraliser, organiser et analyser les informations de suivi. Il est conçu pour améliorer la performance et la prise de décision des professionnels.",
  "article.faq.q2": "Hipobuy Spreadsheet est-il compatible avec Google Sheets ?",
  "article.faq.a2": "Oui, Hipobuy Spreadsheet est entièrement compatible avec Google Sheets, Notion et Excel. Vous pouvez importer et exporter vos données sans aucune perte d'information.",
  "article.faq.q3": "Combien coûte Hipobuy Spreadsheet ?",
  "article.faq.a3": "Hipobuy Spreadsheet propose plusieurs formules adaptées à vos besoins. Consultez notre site principal pour découvrir les tarifs et les fonctionnalités incluses.",
  "article.faq.q4": "Puis-je automatiser mes tâches avec Hipobuy Spreadsheet ?",
  "article.faq.a4": "Absolument. Hipobuy Spreadsheet offre des fonctionnalités d'automatisation avancées qui vous permettent de créer des flux de travail automatisés et de réduire le temps passé sur les tâches répétitives.",
  "article.faq.q5": "Hipobuy Spreadsheet est-il sécurisé ?",
  "article.faq.a5": "La sécurité est notre priorité. Hipobuy Spreadsheet respecte les normes GDPR et utilise un chiffrement de bout en bout pour protéger vos données. Aucune donnée n'est revendue à des tiers.",
  "article.related.title": "Articles connexes",
  "article.related.article1": "Comparaison des meilleurs outils spreadsheet",
  "article.related.article2": "Automatisation avancée avec Hipobuy",
  "article.related.article3": "Templates gratuits pour débutants",
  "article.table.title": "Comparaison des outils de spreadsheet",
  "article.table.col1": "Critère",
  "article.table.col2": "Hipobuy Spreadsheet",
  "article.table.col3": "Notion",
  "article.table.col4": "Excel",
  "article.table.row1.col1": "Automatisation",
  "article.table.row1.col2": "Élevée",
  "article.table.row1.col3": "Moyenne",
  "article.table.row1.col4": "Faible",
  "article.table.row2.col1": "Facilité d'utilisation",
  "article.table.row2.col2": "Moyenne",
  "article.table.row2.col3": "Haute",
  "article.table.row2.col4": "Moyenne",
  "article.table.row3.col1": "SEO friendly",
  "article.table.row3.col2": "Oui",
  "article.table.row3.col3": "Oui",
  "article.table.row3.col4": "Non",
  "article.table.row4.col1": "Collaboration",
  "article.table.row4.col2": "Avancée",
  "article.table.row4.col3": "Moyenne",
  "article.table.row4.col4": "Faible",
  "article.table.row5.col1": "Intégration API",
  "article.table.row5.col2": "Oui",
  "article.table.row5.col3": "Limitée",
  "article.table.row5.col4": "Non",
  "article.table2.title": "Performance par fonction",
  "article.table2.col1": "Fonction",
  "article.table2.col2": "Niveau",
  "article.table2.col3": "Impact",
  "article.table2.row1.col1": "Tracking",
  "article.table2.row1.col2": "Avancé",
  "article.table2.row1.col3": "Élevé",
  "article.table2.row2.col1": "Analyse",
  "article.table2.row2.col2": "Moyen",
  "article.table2.row2.col3": "Moyen",
  "article.table2.row3.col1": "Automatisation",
  "article.table2.row3.col2": "Élevé",
  "article.table2.row3.col3": "Très élevé",
  "article.table2.row4.col1": "Reporting",
  "article.table2.row4.col2": "Avancé",
  "article.table2.row4.col3": "Élevé",
  "article.table2.row5.col1": "Alertes",
  "article.table2.row5.col2": "Moyen",
  "article.table2.row5.col3": "Moyen",
  "notfound.title": "Page introuvable",
  "notfound.desc": "La page que vous recherchez n'existe pas ou a été déplacée.",
  "notfound.back": "Retour à l'accueil",
};

export default translation;